/**
 * 運営のログインID(2026-10-13 ユーザー指定)。このIDでログインしている時だけの表示に使う。
 * 表示の切り替えだけで、閲覧の制限ではない(静的サイトなので、ページの情報自体は誰でも取れる)。
 * - 読みもの一覧: 限定公開・予約公開の記事と公開状態の札(plan/43)
 * - プロフィールカード: 試験中は運営だけが作れる(切り替えは constants/profileCard.ts。plan/48)
 */
export const OWNER_USER_ID = "twilightplc";
